import topImg from '../../../assets/images/Landing/top.png';
import { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Login } from "../Dialogs/Login"
import { Register } from "../Dialogs/Register"

export default function Header() {
    const [index, setIndex] = useState(0);
    const texts = ["Watch", "Play", "Create"];
    const controls = useAnimation();
    useEffect(() => {controls.start({ opacity: 1, y: 0 });}, [controls]);
    useEffect(() => {
        const timer = setInterval(() => {
            controls.start({ opacity: 0, y: 20 })
                .then(() => {
                    setIndex((prevIndex) => (prevIndex + 1) % texts.length);
                    controls.start({ opacity: 1, y: 0, transition: { duration: 0.5 } });
                });
        }, 2000);

        return () => clearInterval(timer);
    }, [controls, texts.length]);

    return (
        <div className="px-2 lg:px-32 py-2 mt-40 lg:mt-20 max-w-screen">
            <div className="flex justify-between items-center lg:w-1/2">
                <div className="hidden lg:block absolute left-[-28%] top-[-60%] w-[80%] h-[200%] bg-[#26262c] transform rotate-[14deg] translate-z-[-1px] shadow-custom z-[-1]"></div>
                <img src={topImg} className="hidden lg:block absolute inset-0 left-0 top-5 z-[-4] blur-lg w-full h-auto lg:top-5 md:top-10 md:translate-y-10" />
                <div className="flex flex-col lg:items-start items-center text-center lg:text-start gap-2">
                    <h1 className="text-6xl text-white font-bold flex flex-col">Welcome to <span className="text-shadow-brand text-brand-green">Teamly</span></h1>
                    <p className="text-2xl">
                        The best tournament app for your team.{' '}
                        <motion.span
                            initial={{ opacity: 0, y: 20 }}
                            animate={controls}
                            className="border-b-2 font-bold"
                        >
                            {texts[index]}
                        </motion.span> 
                        {''} tournaments with your friends.
                    </p>
                    <div className="flex gap-4 justify-center">
                        <Register>
                            <button className="border-2 border-brand-green text-white px-5 py-2 text-2xl rounded-xl font-bold hover:bg-brand-green hover:text-white transition duration-300">
                                Start Now
                            </button>
                        </Register>
                        <Login>
                            <button className="bg-brand-green px-5 py-2 rounded-xl text-2xl font-bold hover:bg-green-600 transition duration-300">
                                Login
                            </button>
                        </Login>
                    </div>
                </div>
            </div>
        </div>
    );
}
